import React from "react";
import UsersCommon from "../UsersMain";

const CancellationRequests = () => {
  const type = "Cancelled";
  const title = "Cancelled Users";
  return <UsersCommon type={type} title={title} />;
};

export default CancellationRequests;
